(() => {
  window.PXUTheme = window.PXUTheme || {};
  window.PXUTheme.jsSidebar = {
    init() {
      // Initialize faceted filters
      this.initFacetedFilters();
      
      // Initialize sidebar toggle functionality
      this.initSidebarToggles();
      
      // Handle product sidebar presence
      this.handleProductSidebar();
    },
    
    initFacetedFilters() {
      const facetedFilterForm = document.querySelector('[data-faceted-filter-form]');
      
      if (facetedFilterForm) {
        facetedFilterForm.addEventListener('change', e => {
          if (e.target.type === 'number') return;
          
          const formData = new FormData(facetedFilterForm);
          const facetedFilterSearchParams = new URLSearchParams(formData);
          const existingSearchParams = new URLSearchParams(window.location.search);
          const newSearchParams = new URLSearchParams();
          
          // Add faceted filter params
          for (const [key, value] of facetedFilterSearchParams.entries()) {
            newSearchParams.append(key, value);
          }
          
          // Add existing non-filter params
          for (const [key, value] of existingSearchParams.entries()) {
            if (!key.includes('filter.p') && !key.includes('filter.v')) {
              newSearchParams.append(key, value);
            }
          }
          
          window.location.search = newSearchParams.toString();
        });
      }
    },
    
    initSidebarToggles() {
      // Open initially open blocks
      document.querySelectorAll('[data-sidebar-block__toggle="open"]').forEach(block => {
        this.openSidebarBlock($(block));
      });
      
      // Set up click handlers
      $(document)
        .off('click', '[data-sidebar-block__toggle="closed"]') // Remove previous handlers
        .on('click', '[data-sidebar-block__toggle="closed"]', e => {
          e.preventDefault();
          this.openSidebarBlock($(e.currentTarget));
        });
        
      $(document)
        .off('click', '[data-sidebar-block__toggle="open"]') // Remove previous handlers
        .on('click', '[data-sidebar-block__toggle="open"]', e => {
          e.preventDefault();
          this.closeSidebarBlock($(e.currentTarget));
        });
    },
    
    handleProductSidebar() {
      const $section = $('.section--has-sidebar-option');
      if ($('[data-product-sidebar]').length) {
        $section.addClass('has-sidebar-enabled').removeClass('has-sidebar-disabled');
      } else {
        $section.removeClass('has-sidebar-enabled').addClass('has-sidebar-disabled');
      }
    },
    
    openSidebarBlock($toggleBtn) {
      const $parentBlock = $toggleBtn.closest('.sidebar__block');
      $toggleBtn.attr('data-sidebar-block__toggle', 'open');
      $parentBlock.addClass('is-active').attr('aria-expanded', true);
      $parentBlock.find('[data-sidebar-block__content--collapsible]').stop(true).slideDown();
    },
    
    closeSidebarBlock($toggleBtn) {
      const $parentBlock = $toggleBtn.closest('.sidebar__block');
      $toggleBtn.attr('data-sidebar-block__toggle', 'closed');
      $parentBlock.removeClass('is-active').attr('aria-expanded', false);
      $parentBlock.find('[data-sidebar-block__content--collapsible]').stop(true).slideUp();
    },
    
    unload() {
      $(document).off('click', '[data-sidebar-block__toggle]');
    }
  };
  
  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    if (window.PXUTheme.jsSidebar) {
      window.PXUTheme.jsSidebar.init();
    }
  });
  
  // Initialize on Shopify section load
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', () => {
      if (window.PXUTheme.jsSidebar) {
        window.PXUTheme.jsSidebar.init();
      }
    });
  }
})();